import { useTranslation } from "react-i18next";

export default function LanguageSwitch({ className = "" }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const set = (l) => {
    i18n.changeLanguage(l);
    localStorage.setItem("cfo_lang", l);
  };

  return (
    <div className={`inline-flex items-center rounded-full border border-border bg-card/60 p-0.5 text-xs font-mono-fin ${className}`} data-testid="language-switch">
      <button
        data-testid="lang-fr-btn"
        onClick={() => set("fr")}
        className={`px-2.5 py-1 rounded-full transition-all ${lang === "fr" ? "bg-primary text-white" : "text-muted-foreground hover:text-foreground"}`}
      >FR</button>
      <button
        data-testid="lang-en-btn"
        onClick={() => set("en")}
        className={`px-2.5 py-1 rounded-full transition-all ${lang === "en" ? "bg-primary text-white" : "text-muted-foreground hover:text-foreground"}`}
      >EN</button>
    </div>
  );
}
